document.addEventListener("DOMContentLoaded", function(){


document.querySelectorAll("[data-variant-wrapper]")
.forEach(wrapper => {


const json =
wrapper.querySelector(
"script[type='application/json']"
);


if(!json) return;


const variants =
JSON.parse(json.textContent);



let selectedOptions = [];


const buttons =
wrapper.querySelectorAll(
".custom-option-button"
);



buttons.forEach(button => {


const index =
Number(button.dataset.optionIndex);



if(!selectedOptions[index]){

selectedOptions[index] =
button.dataset.optionValue;

}



button.addEventListener(
"click",
()=>{


buttons
.forEach(btn=>{

if(
btn.dataset.optionIndex ===
button.dataset.optionIndex
){

btn.classList.remove("active");

}

});


button.classList.add("active");



selectedOptions[index] =
button.dataset.optionValue;



updateVariant();


});


});




function updateVariant(){



const variant =
variants.find(v => {


return v.options.every(
(option,index)=>
option === selectedOptions[index]
);


});



if(!variant){

return;

}




const idInput =
wrapper.querySelector(
"input[name='id']"
);


idInput.value =
variant.id;




const image =
wrapper.querySelector(
"img[id^='CustomVariantImage']"
);



if(
image &&
variant.featured_image
){

image.src =
variant.featured_image.src
.replace(
/(\?.*)$/,
""
)
+
"?width=800";

}




const price =
wrapper.querySelector(
"[id^='CustomVariantPrice']"
);



if(price){

price.innerHTML =
Shopify.formatMoney(
variant.price,
window.money_format
);

}




const button =
wrapper.querySelector(
"[id^='CustomAddButton']"
);



const text =
wrapper.querySelector(
"[id^='CustomButtonText']"
);



if(button){


button.disabled =
!variant.available;


}


if(text){


text.textContent =
variant.available
?
"Adicionar ao carrinho"
:
"Sem estoque";


}



}



updateVariant();



});

});